import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from '@/_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItemWithSub'
import {SidebarMenuItem} from '@/_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItem'

const CoreMenu = () => {
  const intl = useIntl()

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            {intl.formatMessage({id: 'CORE.MENU.APPLICATION'})}
          </span>
        </div>
      </div>

      <SidebarMenuItemWithSub
        to='/app/users'
        title={intl.formatMessage({id: 'CORE.MENU.USERS'})}
        icon='profile-user'
      >
        <SidebarMenuItem
          to='/app/users/list'
          title={intl.formatMessage({id: 'CORE.MENU.USERS.LIST'})}
          hasBullet={true}
        />

        <SidebarMenuItem
          to='/app/users/auth'
          title={intl.formatMessage({id: 'CORE.MENU.USERS.AUTH_HISTORY'})}
          hasBullet={true}
        />

        <SidebarMenuItem
          to='/app/users/activity'
          title={intl.formatMessage({id: 'CORE.MENU.USERS.ACTIVITY'})}
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItem
        to='/app/settings'
        title={intl.formatMessage({id: 'CORE.MENU.SETTINGS'})}
        icon='setting-3'
      />

    </>
  )
}

export {CoreMenu}
